import { render, staticRenderFns } from "./ItemGroupList.vue?vue&type=template&id=4dba7554"
import script from "./ItemGroupList.vue?vue&type=script&lang=js"
export * from "./ItemGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports